import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { ITicketPurchased } from '@/features/tickets/types'
import { useUsersInfiniteQuery } from '@/enitites/user/api/queries'
import { computed, ref, watch } from 'vue'
import { UserDB, UsersDBSearchParams } from '@/enitites/user'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { useImage } from '@/shared/composables/image'
import useValidationRules from '@/shared/composables/validation'
import { useAssignTicketToUserMutation } from '@/features/tickets/api/queries'
import BKInput from '@/components/AppShared/BKInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketAssignmentInterface',
  props: {
    ticket: null
  },
  emits: ["close", "successful-assignment"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'successful-assignment'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  ticket: ITicketPurchased
};

// @ts-expect-error Not a ts file




const params = ref<UsersDBSearchParams>({
  pageNumber: 0,
  pageSize: 50,
  keyword: '',
})

const { getImageById } = useImage()
const rules = useValidationRules()
const getUserDB = computed(() => store.getters.getUserDB)
const { data, isFetching: isLoadingUsers } = useUsersInfiniteQuery(params.value)
const { mutate, isPending: isAssigningTicket, error: assignmentError } = useAssignTicketToUserMutation()

const users = computed(() => (data.value ? data.value.pages.flatMap((page) => page) : []))
const selectedUser = ref<Partial<UserDB> | string | null>(props.ticket.assignedTo ? props.ticket.assignedTo : null)
const fullNameForEmail = ref<string>('')
const isUserChanged = computed(() => {
  if (props.ticket.assignedTo && selectedUser.value && typeof selectedUser.value === 'object') {
    return props.ticket.assignedTo.id !== selectedUser.value.id
  }
  if (typeof selectedUser.value === 'string') {
    return props.ticket.assignedTo?.email !== selectedUser.value
  }
  return selectedUser.value !== props.ticket.assignedTo
})

const validate = (value: unknown) => {
  if (typeof value === 'string') {
    return rules.email(value)
  }
  if (value && typeof value === 'object' && ('id' in value || 'userId' in value)) {
    return true
  }
  return 'Please select a valid user or enter a valid email address.'
}

const getAgeByBirthdate = (birthdate: string): number => {
  const today = new Date()
  const birthDate = new Date(birthdate)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }
  return age
}

const handleConfirmAssignment = () => {
  if (!isUserChanged.value || !selectedUser.value || isAssigningTicket.value) return

  const assignedToId =
    typeof selectedUser.value === 'object' && 'id' in selectedUser.value && selectedUser.value.id
      ? selectedUser.value.id
      : undefined
  const assignedToEmail = typeof selectedUser.value === 'string' ? selectedUser.value : undefined

  mutate(
    {
      ticketId: props.ticket.id,
      userId: assignedToId,
      email: assignedToEmail,
      fullName: assignedToEmail ? fullNameForEmail.value : undefined,
    },
    {
      onSuccess: () => {
        emit('successful-assignment')
        emit('close')
      },
    }
  )
}

const updateUserSelectorKey = ref(0)
const handleSelectedUserChange = () => {
  updateUserSelectorKey.value += 1
}

watch(
  () => props.ticket,
  () => {
    selectedUser.value = props.ticket.assignedTo ? props.ticket.assignedTo : null
    fullNameForEmail.value = ''
  }
)

return { __sfc: true,props, emit, params, getImageById, rules, getUserDB, data, isLoadingUsers, mutate, isAssigningTicket, assignmentError, users, selectedUser, fullNameForEmail, isUserChanged, validate, getAgeByBirthdate, handleConfirmAssignment, updateUserSelectorKey, handleSelectedUserChange, AvatarPlaceholder, BKInput }
}

})